import React, { useContext } from 'react';

const Context = React.createContext({
  landbot: null,
  setLandbot: () => {},
});

const Provider = props => (
  <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

const useLandbotContext = () => useContext(Context);

export { Context, Provider, useLandbotContext };
